export default __webpack_public_path__ + "static/media/switch-red.eb897a89.svg";